import { useEffect, useState } from "react";
import image from "../images/logo.png";

import ContactUs from "./ContactUs";
import EnquiryForm from "./EnquiryForm";
import ProcessedFood from "./ProcessedFood";
import Feeds from "./Feeds";
import PremixNutrition from "./PremixNutrition";
import LoadingDots from "./LoadingDots";

function Mainmenu() {
  const [activeFrames, setActiveFrames] = useState([{ id: 1, component: "Frame5" }]); // Root frame

  const handleShowFrame = (parentId, frameName) => {
    setActiveFrames((prevFrames) => [
      ...prevFrames,
      { id: prevFrames.length + 1, parentId, component: frameName },
    ]);
  };

  const renderFrame = (frame) => {
    let FrameComponent = null;
    switch (frame.component) {
      case "Processed Food":
        FrameComponent = ProcessedFood;
        break;
      case "Feeds":
        FrameComponent = Feeds;
        break;
      case "Premix and Nutrition":
        FrameComponent = PremixNutrition;
        break;
        case "Contact":
            FrameComponent = ContactUs;
            break;
            case "EnquiryForm":
                FrameComponent = EnquiryForm;
                break;
      default:
        return null;
    }

    return <FrameComponent key={frame.id} handleShowFrame={handleShowFrame} parentId={frame.id} />;
  };
const [loading, setLoading] = useState(true);
          
              useEffect(() => {
                  setTimeout(() => setLoading(false), 1000);
              }, []);
              //  const [time] = useState(new Date())
  return (
    <>
    {loading ? (<div className='frame1 animated-frame'><LoadingDots /></div>) : (
      <div className="frame1 animated-frame">
       
          Thank You! Team Akaay Feeds is here to resolve all your queries
          Please choose an option below :
          <div style={{textAlign: 'center',marginTop: '2vh'}}>
            <button className="Menubtns" onClick={() => handleShowFrame(1, "Processed Food")}>
            Processed Food
            </button>
            <button className="Menubtns" onClick={() => handleShowFrame(1, "Feeds")}>
            Feeds
            </button>
            <button className="Menubtns" onClick={() => handleShowFrame(1, "Premix and Nutrition")}>
            Premix and Nutrition
            </button>
            <button className="Menubtns" onClick={() => handleShowFrame(1, "Contact")}>
              Contact Us
            </button>
            <div style={{textAlign: 'center'}}>
            <button className="Menubtns" onClick={() => handleShowFrame(1, "EnquiryForm")}>
            Enquiry Form
            </button>
            </div>
          </div>
        </div>
    )}

      {/* Render all active frames in their proper order */}
      {activeFrames.slice(1).map(renderFrame)}
    </>
  );
}

export default Mainmenu;
